import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';

/**
 * @method apiGetConsentGA
 * @method apiGetConsentSurvey
 * @method apiPostConsentSurvey
 */

export default {
    config: function() {
        return Vue.bzbsConfig;
    },


    /**
     * @param {string} token
     */
    apiGetConsentGA: function(strBzbsToken){
        var strUrl = this.config().bzbs_module_url + "/consent/ga";
        return BzbsApi.connectBzbsGet(strUrl, strBzbsToken);
    },

    /**
     * @param {string} token
     */
     apiGetConsentSurvey: function(strBzbsToken){
        var strUrl = this.config().bzbs_module_url + "/consent/survey";
        return BzbsApi.connectBzbsGet(strUrl, strBzbsToken);
    },

    /**
     * @param {string} token
     */
    apiPostConsentSurvey: function(strBzbsToken, params){
        var strUrl = this.config().bzbs_module_url + "/consent/survey";
        return BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params);
    },

};
